/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Error_Missing_TokenInputs */



/**
* | output |
* | --- |
* | "Missing verification token" |
*
* @param {Auth_Verify_Error_Missing_TokenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_error_missing_token = /** @type {((inputs?: Auth_Verify_Error_Missing_TokenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Error_Missing_TokenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jeton de vérification manquant")
	if (locale === "es") return /** @type {LocalizedString} */ ("Token de verificación faltante")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Token de verificação ausente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Token di verifica mancante")
	return /** @type {LocalizedString} */ ("Missing verification token")
});